import React from 'react'
import Modal from '../../../ui_reusable/Modal'
import { Button, Message } from 'rsuite'
import useStandardToaster from '../../../ui_reusable/StandardToaster'
import { useQueryClient } from '@tanstack/react-query'
import type { Dataset } from '../../../../api/generated/models'

interface DeleteDatasetProps {
  dataset: Dataset
  onSuccess: () => void
  open: boolean
  onClose: () => void
}

const DeleteDataset: React.FC<DeleteDatasetProps> = ({
  dataset,
  onSuccess,
  open,
  onClose,
}) => {
  const { pushToast } = useStandardToaster()
  const queryClient = useQueryClient()
  const handleSubmit = async () => {
    try {
      // Convert ID to string to match Django's URL pattern expectation
      const datasetId = String(dataset.id)
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/api/datasets/${datasetId}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
          },
          method: 'DELETE',
        },
      )

      if (response.status !== 204) {
        throw new Error('Failed to delete dataset')
      }

      // Invalidate driver list queries to refresh the databook
      queryClient.invalidateQueries({
        queryKey: ['/api/v2/datasets/drivers/with-channels'],
      })
      queryClient.invalidateQueries({
        queryKey: ['/api/v2/datasets/drivers/without-channels'],
      })
        queryClient.invalidateQueries({
          queryKey: ['/api/v2/datasets/drivers/'],
        })

      onSuccess()
      pushToast(
        <Message type="success">
          {dataset.name} has been deleted successfully
        </Message>,
        { placement: 'topCenter', duration: 5000 },
      )
      onClose()
    } catch (error: any) {
      pushToast(
        <Message type="error">
          {error.message || 'Failed to delete dataset'}
        </Message>,
        { placement: 'topCenter', duration: 5000 },
      )
    }
  }

  return (
    <Modal open={open} onClose={onClose} title={`Delete ${dataset.name}`}>
      <Modal.Body>
        <p>Are you sure to delete?</p>
      </Modal.Body>
      <Modal.Footer>
        <Button
          type="submit"
          onClick={handleSubmit}
          appearance="primary"
          color="violet"
        >
          Yes
        </Button>
        <Button type="submit" onClick={onClose} appearance="subtle">
          No
        </Button>
      </Modal.Footer>
    </Modal>
  )
}

export default DeleteDataset
